import { PlayCircleIcon } from '@phosphor-icons/react';
import Fancybox from '../../lib/FancyBox';

const YoutubeVideoSolution = ({
  videoId,
  videoThumbnail = null,
  isSolution = true,
  testId = null,
  testTitle = null,
  subjectTitle = null,
  chapterTitle = null,
  topicTitle = null,
  conceptTitle = null,
  questionType = null,
  questionLevel = null,
  attemptStatus = null,
  source = null,
}) => {
  const selectedPack = JSON.parse(window.localStorage.getItem('selectedPack') || 'null');
  const user = JSON.parse(window.localStorage.getItem('userProfile') || 'null');

  const handleVideoClick = () => {
    if (!isSolution) {
      window.webengage?.track('Watched Video Analysis', {
        'User Id': user?.email,
        'Pack Id': selectedPack?._id,
        'Pack Name': selectedPack?.title,
        'Exam Name': selectedPack?.exam?.title,
        'Test Id': testId,
        'Test Name': testTitle,
      });
    } else {
      window.webengage?.track('Watched Video Solution', {
        'User Id': user?.email,
        'Pack Id': selectedPack?._id,
        'Test Id': testId,
        'Test Name': testTitle,
        'Pack Name': selectedPack?.title,
        'Exam Name': selectedPack?.exam?.title,
        'Subject Name': subjectTitle,
        'Chapter Name': chapterTitle,
        'Topic Name': topicTitle,
        'Concept Name': conceptTitle,
        'Question Type': questionType,
        'Question Level': questionLevel,
        'Attempt Status': attemptStatus,
        Source: source,
      });
    }
  };

  return (
    <div>
      {isSolution && <span className="font-medium text-[13px] text-[var(--q3-neutral-light)]">VIDEO SOLUTION</span>}
      <div className={`${isSolution && 'mt-3'}`}>
        <Fancybox>
          <a
            href={`https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`}
            data-fancybox
            data-type="iframe"
            className={`relative block ${isSolution ? 'w-fit' : 'w-full'} overflow-hidden`}
            onClick={handleVideoClick}
          >
            <img
              src={videoThumbnail || `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
              alt="Video thumbnail"
              className={`object-cover ${isSolution ? 'w-2xs' : 'w-full'} h-auto rounded-xl`}
            />
            <div className="absolute inset-0 bg-black opacity-30 rounded-xl" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-[var(--q3-surface-dim)] text-[var(--q3-neutral-default)] p-2 border border-[var(--q3-neutral-default)] rounded-full shadow text-sm font-medium flex items-center gap-2">
                <PlayCircleIcon size={20} />
                <span>View {isSolution ? 'Solution' : 'Analysis'}</span>
              </div>
            </div>
          </a>
        </Fancybox>
      </div>
    </div>
  );
};

export default YoutubeVideoSolution;
